import { LettersSection } from "../LettersSection/LettersSection";

export const LettersSickCertsPanel = ({ patientId, patient }) => (
  <LettersSection patientId={patientId} patient={patient} />
);
